import React, { useState, useEffect, useRef } from "react";
import footbal from "../../../assets/customerAssets/football.png";
import { Box, Button, ImageListItem, FormHelperText } from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import cameraIcon from "../../../assets/customerAssets/icons/camera.svg";
import { supportedImageFileTypes } from "../../../helper/commonFunctions";
import { toast } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";

const FormProfileComponent = ({ formik, edited }) => {
  //   const [img, setImg] = useState(null);
  const [imgPreview, setImgPreview] = useState(() =>
    edited
      ? formik.values.club_img
      : formik.values.club_img
      ? URL.createObjectURL(formik.values.club_img)
      : null
  );
  const imageInputRef = useRef(null);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      imgPreview == null && toast.error("Please select a file");
      return;
    }
    const fileType = file.type.split("/")[1];
    const fileExt = file.name.split(".").pop().toLowerCase();

    if (
      supportedImageFileTypes.includes(file.type) === false &&
      supportedImageFileTypes.includes(fileExt) === false
    ) {
      toast.error("Please select a valid image file");
      return;
    }

    // setImg(URL.createObjectURL(file));
    setImgPreview(URL.createObjectURL(file));
    formik.setFieldValue("club_img", file);
    formik.setFieldTouched("club_img", true);
  };

  // console.log(
  //   formik.values.club_img,
  //   "formik.values.club_img",
  //   imgPreview,
  //   "preview image state"
  // );

  return (
    <>
      <Box className="formProfile">
        <input
          type="file"
          name="club_img"
          accept="image/*"
          onChange={handleChange}
          onBlur={formik.handleBlur}
          style={{ display: "none" }}
          ref={imageInputRef}
        />
        <Box className="option-outter" sx={{ padding: "0" }}>
          <div className="option-inner">
            <img
              src={imgPreview ? imgPreview : footbal}
              alt="football"
              className="img_fluid"
              style={imgPreview ? { objectFit: "cover" } : { opacity: "24%" }}
            />
          </div>
        </Box>

        <Button
          className="icon-wrapper"
          onClick={() => imageInputRef.current.click()}
        >
          <div className="img-div">
            <img src={cameraIcon} alt="camera" className="img_fluid" />
          </div>
        </Button>
      </Box>
      {formik.errors.club_img ? (
        <FormHelperText sx={{ color: "red" }}>
          {formik.errors.club_img}
        </FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};

export default FormProfileComponent;
